import UIChangeArrow from 'UIComponents/icon/icons/UIChangeArrow';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PercentChange = ({
  value
}) => {
  const use = value >= 0 ? 'increase' : 'decrease';
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [value && /*#__PURE__*/_jsx(UIChangeArrow, {
      use: use
    }), /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedPercentage, {
        precision: 1,
        value: Math.abs(value)
      })
    })]
  });
};
export default PercentChange;